module.exports = __webpack_public_path__ + "img/trash-icon.f5304858.svg";